import React from 'react';
import styled from 'styled-components';

import { ConvertEmojiToUnicode, ConvertUnicodeToEmoji } from '../../Functions';

import { EmojiPicker } from './PickerEmoji.jsx';

const ComponentContainer = styled.div`
  display: flex;
`;
class NotificationReactionPicker extends React.Component {
    onReactToNotification = NewEmoji => {
        this.props.OnChangeReaction({ NewEmoji, NewEmojiUnicode: ConvertEmojiToUnicode(NewEmoji) });
    }

    render() {
        var selectedEmoji = this.props.Reaction ? ConvertUnicodeToEmoji(this.props.Reaction) : undefined;

        return (
            <ComponentContainer>
                <EmojiPicker
                    icon={selectedEmoji}
                    reactionClick={this.onReactToNotification}
                />
            </ComponentContainer>
        );
    }
}

export default NotificationReactionPicker;